import { InjectionToken } from '@angular/core';

import type { ITechnicalLogHandler } from '../services/handlers/i-technical-log.handler';
import type { IResourceTimingProvider } from '../services/providers/i-resource-timing.provider';
import type { ITechnicalLogStoreProvider } from '../services/providers/i-technical-log-store.provider';
import type { IUserActivityProvider } from '../services/providers/i-user-activity.provider';

export const TECHNICAL_LOG_HANDLER = new InjectionToken<ITechnicalLogHandler>(
  'ITechnicalLogHandler',
);

export const TECHNICAL_LOG_STORE_PROVIDER = new InjectionToken<ITechnicalLogStoreProvider>(
  'ITechnicalLogStoreProvider',
);

export const USER_ACTIVITY_PROVIDER = new InjectionToken<IUserActivityProvider>(
  'IUserActivityProvider',
);

export const RESOURCE_TIMING_PROVIDER = new InjectionToken<IResourceTimingProvider>(
  'IResourceTimingProvider',
);
